import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = ["Whānau", "Inclusiveness", "Non-judgemental", "Community", "Opportunity"];

export const ValuesMarquee = ({ light = false }) => (
  <div className={`py-8 overflow-hidden ${light ? "bg-navy" : "bg-cream"}`} data-testid="values-marquee">
    <Marquee speed={45} gradient={false}>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-heading text-5xl md:text-7xl font-medium px-8 ${
              light ? "marquee-stroke-light" : "marquee-stroke"
            }`}
          >
            {item}
          </span>
          <span className={`text-3xl ${light ? "text-gold" : "text-gold"}`}>•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
